import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { TsDataSource, FormatTooltip, SourceTag, InfoTooltip } from "../index";
import { useEffect, useState } from "react";
function EntityMetaTooltip(props) {
    const { baseUrl, field, endpoint } = props;
    const [attributeDeatils, setAttributeDetails] = useState({});
    const ds = new TsDataSource({ baseUrl: baseUrl });
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            ds.getEntityMeta().then((meta) => {
                const attribute = meta.flatAttributes[endpoint][field];
                if (attribute) {
                    const atts = {
                        "Authorative": attribute.authorative,
                        "Available on Relationship": attribute.available_on_relationship,
                        "Cardinality": attribute.cardinality,
                        "Description": attribute.description,
                        "Display Name": attribute.display_name,
                        "Python Type": attribute.python_type,
                        "Source": _jsx(SourceTag, { source: attribute.source, className: "tol-entity-meta-tool-tip-source" }),
                    };
                    setAttributeDetails(atts);
                }
            });
        }
        ;
        return () => { isMounted = false; };
    }, [field]);
    const tooltip = _jsx(FormatTooltip, { contents: attributeDeatils });
    if (Object.keys(attributeDeatils).length === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(InfoTooltip, { contents: tooltip }));
}
export default EntityMetaTooltip;
